// extracted by mini-css-extract-plugin
export default {"list":"DaysList_list__0SKqL","day":"DaysList_day__RSsOP"};